/* eslint-disable no-var */
import { JJMCIFrame as JJMCIFrameClass } from 'client/modules/external-sharing/public/jjmc-iframe';

window.JJMCIFrame = JJMCIFrameClass;

declare global {
  var JJMCIFrame: typeof JJMCIFrameClass;
}
